import { call, put } from 'redux-saga/effects';
import {
  fetchProvinceSuccess,
  fetchProvinceFailed,
  fetchDistrictSuccess,
  fetchDistrictFailed,
  fetchWardSuccess,
  fetchWardFailed
} from 'actions/location'

import {
  getProvinces,
  getDistricts,
  getWards,
} from 'apis/location'
import {STATUS_CODE} from 'constants/index'


export function* fetchProvinces({ payload }) {
  try {
    const { params } = payload;
    const resp = yield call(getProvinces, params);
    const { data, status } = resp;
    if (status === STATUS_CODE.SUCCESS) {
      yield put(fetchProvinceSuccess(data));
    } else {
      yield put(fetchProvinceFailed(data));
    }
  } catch (error) {
  }
}

export function* fetchDistricts({ payload }) {
  try {
    const { params } = payload;
    const resp = yield call(getDistricts, params);
    const { data, status } = resp;
    if (status === STATUS_CODE.SUCCESS) {
      yield put(fetchDistrictSuccess(data));
    } else {
      yield put(fetchDistrictFailed(data));
    }
  } catch (error) {
  }
}

export function* fetchWards({ payload }) {
  try {
    const { params } = payload;
    const resp = yield call(getWards, params);
    const { data, status } = resp;
    if (status === STATUS_CODE.SUCCESS) {
      yield put(fetchWardSuccess(data));
    } else {
      yield put(fetchWardFailed(data));
    }
  } catch (error) {
  }
}
